import {Controller} from 'stimulus';
import ImageResizer from '../helpers/image_resizer';

export default class extends Controller {
  static targets = [
    'dropZone', 'fileInput', 'fileInputDetach', 'noImageWrap', 'imageWrap', 'image',
  ];

  connect() {
    this.acceptedTypes = this._acceptedImageTypesFromMeta();

    this.dropZoneTarget.addEventListener('dragover', (e) => this.dragover(e));
    this.dropZoneTarget.addEventListener('dragenter', (e) => this.dragover(e));
    this.dropZoneTarget.addEventListener('dragleave', (e) => this.dragleave(e));
    this.dropZoneTarget.addEventListener('dragend', (e) => this.dragleave(e));
    this.dropZoneTarget.addEventListener('drop', (e) => this.drop(e));
    this.fileInputTarget.addEventListener('change', (e) => this.handleFileSelection(e));
  }

  dragover(e) {
    this.dropZoneTarget.classList.add('active');
    e.preventDefault();
    e.stopPropagation();
  }

  dragleave(e) {
    this.dropZoneTarget.classList.remove('active');
    e.preventDefault();
    e.stopPropagation();
  }

  async drop(e) {
    e.preventDefault();
    e.stopPropagation();
    this.dropZoneTarget.classList.remove('active');

    const files = e.dataTransfer.files;
    if (files.length && this._validateFileType(files[0])) {
      const processedFile = await ImageResizer.processFile(files[0], {
        onStart: () => this._showResizingState(true),
        onComplete: () => this._showResizingState(false),
      });
      this._setFileInputFile(processedFile);
      this.fileInputDetachTarget.value = false;
      this.preview();
    }
  }

  async handleFileSelection(e) {
    const file = e.target.files[0];
    if (file && this._validateFileType(file)) {
      const processedFile = await ImageResizer.processFile(file, {
        onStart: () => this._showResizingState(true),
        onComplete: () => this._showResizingState(false),
      });
      this._setFileInputFile(processedFile);
      this.preview();
    } else {
      this.fileInputTarget.value = null;
    }
  }

  edit(e) {
    this.fileInputTarget.click();
    e.stopPropagation();
  }

  delete(e) {
    const result = confirm(this.data.get('deleteConfirm'));
    if (result === true) {
      this.imageWrapTarget.classList.add('d-none');
      this.noImageWrapTarget.classList.remove('d-none');
      this.fileInputTarget.value = null;
      this.fileInputTarget.dispatchEvent(new Event('delete'));
      this.fileInputDetachTarget.value = true;
    }
    e.stopPropagation();
  }

  preview() {
    this.imageTarget.src = URL.createObjectURL(this.fileInputTarget.files[0]);
    this.imageWrapTarget.classList.remove('d-none');
    this.noImageWrapTarget.classList.add('d-none');

    const invalidIndicator = this.element.closest('.is-invalid');
    if (invalidIndicator) {
      invalidIndicator.classList.remove('is-invalid');
    }
  }

  _validateFileType(file) {
    if (!this.acceptedTypes.includes(file.type)) {
      alert('Ongeldig bestandstype. Alleen afbeeldingen (JPEG, PNG, GIF) zijn toegestaan.');
      return false;
    }
    return true;
  }

  _setFileInputFile(file) {
    // Use DataTransfer API to set file input value
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    this.fileInputTarget.files = dataTransfer.files;
  }

  _acceptedImageTypesFromMeta() {
    const meta = document.querySelector('meta[name="accepted-image-types"]');
    return meta?.content?.split(',') || ['image/jpeg', 'image/png'];
  }

  _showResizingState(visible) {
    if (visible) {
      this.dropZoneTarget.classList.add('resizing');
      this._resizingStartTime = Date.now();
    } else {
      // Ensure spinner shows for at least 500ms for user feedback
      const elapsed = Date.now() - (this._resizingStartTime || 0);
      const minDelay = Math.max(0, 500 - elapsed);
      setTimeout(() => {
        this.dropZoneTarget.classList.remove('resizing');
      }, minDelay);
    }
  }
}
